

function CustomCard(props) {
    const { label, imagesrc } = props;

    return (
        <div>
            <div className="service-card">
                <div className="row" style={{paddingTop: '10px'}}>
                    <div className="col align-self-center">
                        <h4 className="hind-mysuru-semibold blue-text">{label}</h4>
                    </div>
                    <div className="col-auto">  
                        <img className="card-icon" src={imagesrc} alt='icon'></img>
                    </div>
                </div>
                <div className="row main-font" style={{fontWeight: "200", fontSize: "1.2em", paddingRight:'40px'}}>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default CustomCard